module.exports = __webpack_public_path__ + "static/media/female-musculature.c7c3b342.png";